import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * OCORRÊNCIAS E ATESTADOS DO ESTUDANTE — migração de `MenuAcademico/CadastrarAtestadoOcorrencia.aspx`,
 * que o legado abria duas vezes: `?tipo=O` (Ocorrências, Advertências e Suspensões) e `?tipo=A`
 * (Atestados). As duas gravam na MESMA tabela (`ATESTADO`, discriminada pela coluna `TIPO`), e aqui
 * também são UMA tela: o que muda é o `meta.tipoRegistro` de cada rota.
 *
 * Cada uma tem permissão PRÓPRIA e vizinha da legada (300100400 → 300100499, 300100500 →
 * 300100549): a rede libera Ocorrências sem liberar Atestados, como já fazia no legado. O relatório
 * por período (`EmitirAtestadoOcorrencia.aspx`, uma janela à parte) é um botão da própria tela.
 */
export default [
  {
    description: 'Ocorrências, Advertências e Suspensões',
    path: '/academico/ocorrencias',
    name: 'ocorrencias_estudante',
    component: () => import('@/views/academico/ocorrencias/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.OCORRENCIASDOESTUDANTENOVO_MENU_300100499],
      tipoRegistro: 'O',
    },
    goesToMenu: true,
  },
  {
    description: 'Atestados',
    path: '/academico/atestados',
    name: 'atestados_estudante',
    component: () => import('@/views/academico/ocorrencias/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ATESTADOSDOESTUDANTENOVO_MENU_300100549],
      tipoRegistro: 'A',
    },
    goesToMenu: true,
  },
];
